module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_old_coin_ce7059344f6b9cfe7c2d8e43e6024855.png";